import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import {
  doc,
  getDoc,
  setDoc,
  collection,
  query,
  where,
  updateDoc,
  arrayUnion,
  getDocs,
  deleteDoc,
  limit,
  orderBy,
} from "firebase/firestore";
import { db } from "../../config/FirebaseConfig.js"; // Import the Firebase setup
import addLogDocument from "../addLogDocument"; // Assuming this function exists for logging
import updateDocApi from "../database/updateDocApi.js";
import updateDocDataFieldApi from "../database/updateDocDataFieldApi.js";
import { checkDB } from "../../models/DataFunctions.js";

const sendFileFU = async (
  uploadedlist,
  oid,
  token,
  folderconvRef,
  content,
  senderRef,
  folderid,
  prefix
) => {
  const auth = getAuthCentral();
  const currentUser = auth.currentUser;

  if (!currentUser) {
    console.error("User not logged in");
    return;
  }

  const userRef = doc(db, "user", currentUser.uid);
  const userSnapshot = await getDoc(checkDB(userRef));
  const org_id = userSnapshot.get("org_id");

  // Create a new message document
  const newMessageRef = doc(collection(db, "message"));
  await setDoc(newMessageRef, {
    content: content,
    author_id: senderRef?.id || "particulier",
    post_date: new Date(),
  });
  let folderconv = await getDoc(folderconvRef);
  let folderconvData = folderconv.data();
  let messages = folderconvData.messages || [];
  messages.push(newMessageRef);

  // Update the folder conversation
  await updateDocDataFieldApi(folderconvRef, "messages", messages, prefix);

  try {
    let start = new Date();
    for (const up of uploadedlist) {
      const fileUrl = up.url;

      // Download the file from the provided URL
      const fileResponse = await fetch(fileUrl);
      if (fileResponse.ok) {
        const fileBlob = await fileResponse.blob();
        const fileName = fileUrl.split("/").pop().replace(/\s+/g, "_");
        const url =
          prefix + `folders/${folderid}/message/${newMessageRef.id}/file`;

        // Create a FormData object to prepare the file for upload
        const formData = new FormData();
        formData.append("file", fileBlob, fileName);
        formData.append("format", "pdf");

        // Send the request using fetch
        const response = await fetch(url, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        });
        let end = new Date();
        let elapsed = end - start;
        // Log the response
        await addLogDocument(
          url,
          prefix,
          userRef,
          getEventsByOrgRef,
          response.status.toString(),
          "", // folderid
          "", // docid
          JSON.stringify({ fileName, format: "pdf" }),
          response.statusText,
          "POST",
          elapsed
        );

        if (response.ok) {
        } else {
          console.error(`Error response: ${response.status}`);
        }
      } else {
        console.error(`Failed to download file: ${fileResponse.status}`);
      }
    }
  } catch (error) {
    console.error(`Error selecting/uploading file: ${error.message}`);
  }
};

export default sendFileFU;
